import {
  magnificPopupIframe,
  magnificPopupInline,
  magnificPopupSingleImage,
  magnificPopupGalleryImage,
} from '@js/popups'
import { basicSlider } from '@js/sliders'
import { linksCustomization, scrollTo, responsiveTables } from '@js/misc'
import buttons from '@js/buttons'
import setScrollBarWidth from 'set-scrollbar-width' // Use with the Tailwind Container Break Out extension.



// Sections
import { menu } from '@/templates/sections/menu'
import whereNext from '@/templates/sections/where-next'

// Templates

// Parts
import footer from '@js/parts/footer'

// Flexible Content
import accordion from '@/templates/blocks/accordion'
import singleMedia from '@/templates/blocks/single-media'
import quotes from '@/templates/blocks/quotes'
import imagesQuotesSlider from '@/templates/blocks/images-quotes-slider'
import announcementsSlider from '../../templates/blocks/latest-announcements/latest-announcements'
import faqs from '../../templates/blocks/faqs/faqs'
import { rotatingWords } from '../../templates/blocks/rotating-words/rotating-words'

// Animations
import scrollAnimations from './scrollAnimations'
import parallax from './parallax'

function consoleMessage() {
  console.log(
    '%cCreated by %cTWK%cwww.thewebkitchen.co.uk',
    'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;',
    'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;',
    'background: #FFFFFF; padding: 5px 10px;'
  )
}

function usingJS() {
  document.querySelector('html').classList.remove('no-js')
  document.querySelector('html').classList.add('js')
}

/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function () {
  // Init
  consoleMessage()
  usingJS()
  buttons()
  setScrollBarWidth()
  linksCustomization()
  scrollTo()
  responsiveTables()

  // Popups
  magnificPopupIframe()
  magnificPopupInline()
  magnificPopupSingleImage()
  magnificPopupGalleryImage()

  // Sections
  whereNext()

  // Templates
  rotatingWords()

  // Parts
  footer()

  // Sliders
  basicSlider()
  announcementsSlider()

  // Flexible Content
  accordion()
  singleMedia()
  quotes()
  imagesQuotesSlider()
  faqs()

  // Scroll Animations
  scrollAnimations()
  parallax()
}

jQuery(document).ready(function ($) {
  ajax: {
    /**
     * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
     */
    $(document).on('sf:ajaxfinish', '.searchandfilter', function () {
      magnificPopupIframe()
      magnificPopupInline()
      magnificPopupSingleImage()
      magnificPopupGalleryImage()
    })
  }

  $('.prose p > img').unwrap('p')
  $('.prose p > .button').unwrap('p')
  $('.prose p > .button-download').unwrap('p')
  $(
    '.prose iframe[src*="youtube"], .prose iframe[data-src*="youtube"], .prose iframe[src*="vimeo"], .prose iframe[data-src*="vimeo"]'
  )
    .unwrap('p')
    .wrap('<div class="iframe-embed"></div>')

  document.querySelector('[data-name="scroll-down"').addEventListener('click', function () {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    })
  })

})
